import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { IMPORT_SUMMARY_CONST } from '../../../constants';
import { postImportEvents } from '../../actions/actionType/events/ImportActionTypes';
import {
  clearImportEvents,
  fetchImportFailure,
  fetchImportStarted,
  fetchImportSuccess
} from '../../actions/sagaActions/events/ImportEventsSagaAction';
import { FetchImportFailurePayload, FetchImportRequest } from '../../actions/types/events/ImportEventSummaryTypes';

export async function callImportEventsApi(data: FormData) {
  return apiWrapper.post<string>(
    `${process.env.REACT_APP_API_BASE_URL}/exim/import?recordType=${IMPORT_SUMMARY_CONST.event}`,
    data,
    {},
    'multipart/form-data',
  );
}
export function* postImportEventApi({
  fileData,
}: FetchImportRequest) {
  yield put(clearImportEvents());
  yield put(fetchImportStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callImportEventsApi, fileData);
    if (isError) {
      throw error;
    }
    // put length check here
    if (data) {
      yield put(fetchImportSuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error: any) {
    const obj: FetchImportFailurePayload = {
      errorCode: String(error?.response?.data.error_code),
      errorMessage: String(error?.response?.data?.errorMessage)
    };
    yield put(fetchImportFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* importEventSaga() {
  yield takeLatest(postImportEvents.POST_IMPORT_EVENTS_REQUEST, postImportEventApi);
}

export const importEventSagaHandler = [fork(importEventSaga)];
